<template>
  <div id="app" class="flex flex-col h-screen mx-auto p-4 bg-gradient-to-br from-blue-600 via-indigo-500 to-purple-700 relative">
    <!-- Animated Background Elements -->
    <div class="absolute top-0 left-0 w-full h-full overflow-hidden z-0">
      <div class="absolute w-96 h-96 bg-white opacity-10 rounded-full -top-20 -left-20 animate-pulse-slow"></div>
      <div class="absolute w-80 h-80 bg-blue-300 opacity-10 rounded-full top-40 right-10 animate-float"></div>
      <div class="absolute w-64 h-64 bg-purple-300 opacity-10 rounded-full bottom-20 left-40 animate-float-delayed"></div>
    </div>
    
    <div class="mb-4 relative z-10">
      <router-link to="/" class="no-underline text-white">
        <div class="logo-text-chat flex items-center">
          <span class="text-white">inter<span class="text-yellow-300">bot</span></span>
          <div class="ml-2 bg-yellow-300 p-1 rounded-md">
            <span class="text-xs font-bold text-blue-700">IA</span>
          </div>
        </div>
      </router-link>
    </div>
    
    <InterviewChat
      :chatSessionId="chatSessionId"
      @goToAnalysis="goToAnalysis"
    />
  </div>
</template>
  
  <script>
  import InterviewChat from '../components/InterviewChat.vue';
  import axios from 'axios';
  
  export default {
    name: 'DirectChatView',
    components: {
      InterviewChat,
    },
    data() {
      return {
        chatSessionId: null,
      };
    },
    async mounted() {
      this.startNewSession();
    },
    methods: {
      async startNewSession() {
        await this.generateInterviewCode();
      },
      async generateInterviewCode() {
        try {
          const response = await axios.post(`./api/generate-practice`, {interviewFocus: 'practice'});
          this.chatSessionId = response.data.chatSessionId;
          this.interviewCodeGenerated = true;
          localStorage.setItem('chatSessionId', this.chatSessionId);
        } catch (error) {
          console.error("Error al generar el código", error)
        }
      },
      goToAnalysis() {
        this.$router.push({ path: '/analysis', query: { code: this.chatSessionId } });
      },
    },
  };
  </script>
  
  <style scoped>
  @keyframes pulse-slow {
    0%, 100% {
      opacity: 0.7;
    }
    50% {
      opacity: 0.3;
    }
  }

  @keyframes float {
    0%, 100% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(-20px);
    }
  }

  @keyframes float-delayed {
    0%, 100% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(-15px);
    }
  }

  .animate-pulse-slow {
    animation: pulse-slow 4s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  }

  .animate-float {
    animation: float 8s ease-in-out infinite;
  }

  .animate-float-delayed {
    animation: float-delayed 7s ease-in-out infinite;
    animation-delay: 2s;
  }

  /* Apply blur effect for glass morphism */
  .backdrop-blur-sm {
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
  }
  </style>